import './xy-legend.css';
export var shapeIconWrapper = '_1lwufqz0-3-5-0';